// extracted by mini-css-extract-plugin
export default {"header":"_31eJJXbD","headerContainer":"_20xGrxG9","editBtn":"_3xx1ipPV","editWrp":"t-TaD-L_","panel":"_3sD5HdC2","loader":"_375IEKtc","inHeader":"WvUirXgm"};